import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';

export type TrackableFood = {
  category: string;
  id: string;
  image_url: string | null;
  name: string;
};

type UserFoodsResponse = {
  foods: TrackableFood[];
};

export const useTrackableFoods = (userId: string = '') => {
  const { api } = useApi({ throwIfError: true });
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchTrackableFoods = async (): Promise<UserFoodsResponse> => {
    return api({
      route: `/private/user/foods?all_foods=true`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId,
      },
    });
  };

  const { data, isLoading, error } = useQuery<UserFoodsResponse, any>(
    ['hc-trackable-foods', userToken, userId],
    fetchTrackableFoods,
    {
      enabled: isAuthenticated && !loading && !!userToken && !!userId,
      refetchOnWindowFocus: false,
    }
  );

  return { foods: data?.foods, isLoading, error };
};
